import { Component } from '@angular/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { RouterFacade } from '@cigna/shared/angular/core/router-state-data-access';

@Component({
  selector: 'cigna-block',
  templateUrl: './block.component.html',
  styleUrl: './block.component.scss',
})
export class BlockComponent {
  queryParams$ = this.routerFacade.queryParams$;

  constructor(private routerFacade: RouterFacade) {}
}
